// extracted by mini-css-extract-plugin
export default {"details":"TaskDetails_details__yDHbu","accordionTitle":"TaskDetails_accordionTitle__MLgZh","container":"TaskDetails_container__87kii"};